import { render, staticRenderFns } from "./TabOrderDetail.vue?vue&type=template&id=cc5d0a9c&"
import script from "./TabOrderDetail.js?vue&type=script&lang=js&"
export * from "./TabOrderDetail.js?vue&type=script&lang=js&"
import style0 from "./TabOrderDetail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TabOrderDetail.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fuseraccount%2FTabOrderDetail%2FTabOrderDetail.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports